module.exports = __webpack_public_path__ + "img/materials-box_small.434527d9.webp";